// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"bd25b79b","106":"6e433fa7","254":"87ba50e4","453":"175433d1","487":"19295ab8","694":"96f08982","706":"0896becf"}[chunkId] + ".chunk.js";
};